import { TableCell } from '@tiptap/extension-table-cell';

export const InlineTableCell = TableCell.extend({
   content: 'paragraph',
   allowGapCursor: false,

   addAttributes() {
      return {
         ...this.parent?.(),
         colwidth: {
            default: [100],
            parseHTML: element => {
               const colwidth = element.getAttribute('colwidth');
               const value = colwidth ? [parseInt(colwidth, 10)] : null;

               return value;
            },
         },
      };
   },
});
